import { render, staticRenderFns } from "./orgcompanydiscount-add-or-update.vue?vue&type=template&id=45a419f6&"
import script from "./orgcompanydiscount-add-or-update.vue?vue&type=script&lang=js&"
export * from "./orgcompanydiscount-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports